export default function handleLocalUrlChange(url) {
  if (url !== undefined) {
    if (url.startsWith('https://www.bluecurrent.nl/')) return url.replace('https://www.bluecurrent.nl/', '/');
    return url;
  }
  return null;
}
